import VueRouter, { RouteConfig } from 'vue-router'
import { GlobalConfigRouteMetaEnum } from 'kuaidong-model'

import RExamRecordStandard, {
  navigateToExamRecordStandardList,
  navigateToExamRecordStandardDetails,
} from './RExamRecordStandard'

import examMenuIcon from '@/assets/images/icon_menu_exam@2x.png'
import examMenuIconActive from '@/assets/images/icon_menu_exam_active@2x.png'

const Layout = () => import('../views/Layout.vue')
const List = () => import('@/views/ExamList.vue')
const Edit = () => import('@/views/ExamEdit.vue')
const Detail = () => import('@/views/ExamDetail.vue')
const DetailInfo = () => import('@/views/ExamDetailInfo.vue')
const DetailStat = () => import('@/views/ExamDetailStat.vue')
const Landing = () => import('../views/intelligent-exam/Landing.vue')

const PracticeList = () => import('../views/ExamPracticeList.vue')
const PracticeEdit = () => import('../views/ExamPracticeEdit.vue')
const PracticeCheck = () => import('../views/ExamPracticeCheck.vue')
const PracticeDetails = () => import('../views/ExamPracticeDetails.vue')

const ExamRecordStateSchoolList = () => import('../views/ExamRecordStateSchoolList.vue')
const ExamRecordStateClazzList = () => import('../views/ExamRecordStateClazzList.vue')
const ExamRecordStateStudentList = () => import('../views/ExamRecordStateStudentList.vue')

const DataSummary = () => import('../views/ExamDataSummary.vue')
const DataClassSummary = () => import('../views/ExamDataClassSummary.vue')
const DataClassJobs = () => import('../views/ExamDataClassJobs.vue')
const DataJobs = () => import('../views/ExamDataJobs.vue')
const DataGrades = () => import('../views/ExamDataGrades.vue')
const DataRateSummary = () => import('../views/ExamDataRateSummary.vue')
const RecordList = () => import('../views/ExamRecordList.vue')
const RecordDetails = () => import('../views/ExamRecordDetails.vue')
const RecordDetailsAdjust = () => import('../views/ExamRecordDetailsAdjust.vue')

export const listRoute: RouteConfig = {
  path: 'index',
  name: 'exam_list',
  component: List,
  meta: { title: '学生自测', showMenu: true },
}

export const EditRoute: RouteConfig = {
  path: 'edit',
  name: 'exam_edit',
  component: Edit,
  props: (route) => ({ id: route.query.id }),
  meta: {
    title: '学生自测',
    [GlobalConfigRouteMetaEnum.All]: true,
  },
}

export const DetailRoute: RouteConfig = {
  path: 'detail',
  name: 'exam_detail',
  component: Detail,
  children: [
    {
      path: 'stat',
      name: 'exam_detail_stat',
      component: DetailStat,
      props: (route) => ({ ...route.query, ...route.params }),
      meta: { title: '学生自测' },
    },
    {
      path: 'info',
      name: 'exam_detail_info',
      component: DetailInfo,
      props: (route) => ({ ...route.query, ...route.params }),
      meta: { title: '学生自测' },
    },
  ],
}

export const landingRoute: RouteConfig = {
  path: 'landing',
  name: 'intelligent_exam_landing',
  component: Landing,
  meta: {
    title: '智能体质测试',
    showMenu: true,
  },
}

export const practiceListRoute: RouteConfig = {
  path: 'practice-list',
  name: 'exam_practice_list',
  component: PracticeList,
  meta: {
    title: '体测练习',
    showMenu: false,
  },
}

export const practiceEditRoute: RouteConfig = {
  path: 'practice-edit',
  name: 'exam_practice_edit',
  component: PracticeEdit,
  meta: {
    title: '体测练习',
  },
}

export const practiceCheckRoute: RouteConfig = {
  path: 'practice-check',
  name: 'exam_practice_check',
  component: PracticeCheck,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体测练习',
  },
}

export const practiceDetailsRoute: RouteConfig = {
  path: 'practice-details',
  name: 'exam_practice_details',
  component: PracticeDetails,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '体测练习',
  },
}

export const dataRoutes: RouteConfig[] = [
  {
    path: 'data-summary',
    name: 'exam_data_summary',
    component: DataSummary,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '分析报告',
    },
  },
  {
    path: 'data-class-summary',
    name: 'exam_data_class_summary',
    component: DataClassSummary,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '分析报告',
    },
  },
  {
    path: 'data-class-jobs',
    name: 'exam_data_class_jobs',
    component: DataClassJobs,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '分析报告',
    },
  },
  {
    path: 'data-jobs',
    name: 'exam_data_jobs',
    component: DataJobs,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '分析报告',
    },
  },
  {
    path: 'data-grades',
    name: 'exam_data_grades',
    component: DataGrades,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '分析报告',
    },
  },
  {
    path: 'data-rate-summary',
    name: 'exam_data_rate_summary',
    component: DataRateSummary,
    props: (route) => ({ ...route.query, ...route.params }),
    meta: {
      title: '分析报告',
    },
  },
]

export const schoolRecordListRoute: RouteConfig = {
  path: 'exam-record-school-record-list',
  name: 'exam_record_school_record_list',
  component: ExamRecordStateSchoolList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '分析报告',
    showMenu: true,
  },
}

export const clazzDataAnalysisRoute: RouteConfig = {
  path: 'exam-record-state-clazz-list',
  name: 'exam_record_state_clazz_list',
  component: ExamRecordStateClazzList,
  props: (route) => ({ ...route.query, ...route.params, body_exam_upload_score_id: route.query.id }),
  meta: {
    title: '分析报告',
  },
}

export const studentDataAnalysisRoute: RouteConfig = {
  path: 'exam-record-state-student-list',
  name: 'exam_record_state_student_list',
  component: ExamRecordStateStudentList,
  props: (route) => ({
    ...route.query,
    ...route.params,
    body_exam_upload_score_id: route.query.id,
    class_no: route.query.cid,
  }),
  meta: {
    title: '分析报告',
  },
}

export const recordListRoute: RouteConfig = {
  path: 'record-list',
  name: 'exam_record_list',
  component: RecordList,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学校跟测',
    showMenu: true,
  },
}

export const recordDetailsRoute: RouteConfig = {
  path: 'record-details',
  name: 'exam_record_details',
  component: RecordDetails,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学校跟测',
  },
}

export const recordDetailsAdjustRoute: RouteConfig = {
  path: 'record-details-adjust',
  name: 'exam_record_details_adjust',
  component: RecordDetailsAdjust,
  props: (route) => ({ ...route.query, ...route.params }),
  meta: {
    title: '学校跟测',
  },
}

export default [
  {
    path: '/exam',
    name: 'exam',
    component: Layout,
    meta: { title: '体质测试', icon: examMenuIcon, iconActive: examMenuIconActive, showMenu: true },
    children: [
      landingRoute,
      listRoute,
      recordListRoute,
      EditRoute,
      DetailRoute,
      practiceListRoute,
      practiceEditRoute,
      practiceCheckRoute,
      practiceDetailsRoute,
      recordDetailsRoute,
      recordDetailsAdjustRoute,
      ...dataRoutes,
      schoolRecordListRoute,
      clazzDataAnalysisRoute,
      studentDataAnalysisRoute,
      ...RExamRecordStandard,
    ],
  },
]

export function navigateToExamPracticeEdit(router: VueRouter) {
  router.push({ name: practiceEditRoute.name })
}

export function navigateToExamPracticeCheck(router: VueRouter, examPracticeId: string) {
  router.push({ name: practiceCheckRoute.name, query: { examPracticeId } })
}

export function redirectToExamPracticeCheck(router: VueRouter, examPracticeId: string) {
  router.replace({ name: practiceCheckRoute.name, query: { examPracticeId } })
}

export function navigateToExamPracticeDetails(router: VueRouter, examPracticeId: string) {
  router.push({ name: practiceDetailsRoute.name, query: { examPracticeId } })
}

export function redirectToExamPracticeDetails(router: VueRouter, examPracticeId: string) {
  router.replace({ name: practiceDetailsRoute.name, query: { examPracticeId } })
}

export function navigateToClazzDataAnalysis(
  router: VueRouter,
  body_exam_upload_score_id: string,
  target_school_id: string
) {
  router.push({ name: clazzDataAnalysisRoute.name, query: { body_exam_upload_score_id, target_school_id } })
}

export function navigateToExamRecordDetails(
  router: VueRouter,
  examRecordId: string,
  name = '',
  showUploadDialog = 'false'
) {
  router.push({ name: recordDetailsRoute.name, query: { examRecordId, name, showUploadDialog } })
}

export function navigateToExamRecordDetailsAdjust(router: VueRouter, examRecordId: string) {
  router.push({ name: recordDetailsAdjustRoute.name, query: { examRecordId } })
}

export { navigateToExamRecordStandardList, navigateToExamRecordStandardDetails }
